import React from 'react';
import Icon from './icons';
import { tx } from './i18n';

// ── Granica bledow (Error Boundary) ──────────────────────────────────────────
// Bez niej KAZDY blad renderowania w dowolnym widoku dawal czarny ekran calej
// aplikacji. Najczestszy przypadek: po wdrozeniu nowej wersji karta otwarta
// wczesniej probuje doczytac stary fragment kodu (lazy chunk), ktorego juz nie
// ma na serwerze -> ChunkLoadError. Wtedy jednorazowo przeladowujemy strone
// (z blokada przed petla); przy innych bledach pokazujemy komunikat w miejscu
// widoku, a menu i reszta aplikacji dzialaja dalej.

const RELOAD_KEY = 'chunk_reload_at';

function isChunkError(error) {
  const msg = String(error?.message || error || '');
  return error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed/i.test(msg)
    || /Failed to fetch dynamically imported module/i.test(msg);
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[HamLogger] Błąd widoku:', error, info?.componentStack);
    if (isChunkError(error)) {
      let last = 0;
      try { last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0; } catch { /* brak storage */ }
      if (Date.now() - last > 60000) {       // najwyzej jedno automatyczne przeladowanie na minute
        try { sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch { /* brak storage */ }
        window.location.reload();
      }
    }
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const chunk = isChunkError(error);
    return (
      <div className={'error-view' + (this.props.fullPage ? ' error-view--page' : '')} role="alert">
        <Icon name={chunk ? 'refresh' : 'bug'} size={28} />
        <h2>{chunk ? tx('Dostępna jest nowa wersja HamLoggera') : tx('Ten widok się nie wczytał')}</h2>
        <p>
          {chunk
            ? tx('Część aplikacji zmieniła się na serwerze. Odśwież stronę, żeby wczytać aktualną wersję.')
            : tx('Coś poszło nie tak podczas wyświetlania. Twoje dane są bezpieczne — spróbuj odświeżyć stronę albo wróć do loggera.')}
        </p>
        <div className="error-view__actions">
          <button type="button" className="btn btn--primary" onClick={() => window.location.reload()}>
            <Icon name="refresh" size={16} /> {tx('Odśwież stronę')}
          </button>
          {this.props.onReset && (
            <button type="button" className="btn btn--ghost" onClick={() => { this.setState({ error: null }); this.props.onReset(); }}>
              <Icon name="mic" size={16} /> {tx('Wróć do loggera')}
            </button>
          )}
        </div>
        {!chunk && <details className="error-view__details"><summary>{tx('Szczegóły techniczne')}</summary><code>{String(error?.message || error)}</code></details>}
      </div>
    );
  }
}
